'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAllLineItems = exports.removeLineItemMixMatchSet = exports.removeLineItem = exports.updateLineItem = exports.addItemsToCart = exports.addItemToCart = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.setDeliveryConfig = setDeliveryConfig;
exports.setFreeGiftTiersConfig = setFreeGiftTiersConfig;
exports.setItemBeingAddedId = setItemBeingAddedId;
exports.setLoading = setLoading;
exports.addError = addError;
exports.toggleError = toggleError;
exports.removeError = removeError;
exports.removeAllErrors = removeAllErrors;
exports.updateLineItems = updateLineItems;

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _errors = require('../../modules/bao-cart/errors');

var _functional = require('../../utils/functional');

var _pushCartTypes = require('../types/push-cart-types');

var pushCartTypes = _interopRequireWildcard(_pushCartTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var addItemToCart = exports.addItemToCart = function addItemToCart(_ref) {
  var id = _ref.id,
      properties = _ref.properties,
      quantity = _ref.quantity;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(setLoading(true));

              _context.prev = 1;
              _context.next = 4;
              return shopifyCart.addItem(id, { properties: properties, quantity: quantity });

            case 4:
              _context.next = 6;
              return shopifyCart.getState();

            case 6:
              data = _context.sent;

              dispatch(updateLineItems(data));
              addBhAttribute(data.attributes);

            case 9:
              _context.prev = 9;

              dispatch(setLoading(false));
              return _context.finish(9);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1,, 9, 12]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var addItemsToCart = exports.addItemsToCart = function addItemsToCart(_ref3) {
  var items = _ref3.items;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(setLoading(true));

              _context2.prev = 1;
              _context2.next = 4;
              return (0, _functional.fetchJSON)('/cart/add.js', {
                method: 'POST',
                body: (0, _stringify2.default)({
                  items: items
                })
              });

            case 4:
              _context2.next = 6;
              return shopifyCart.getState();

            case 6:
              data = _context2.sent;

              dispatch(updateLineItems(data));
              addBhAttribute(data.attributes);

            case 9:
              _context2.prev = 9;

              dispatch(setLoading(false));
              return _context2.finish(9);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[1,, 9, 12]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var addBhAttribute = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(attrs) {
    var isBrandedHouse;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // if its not BH, or BH attr already set, close early
            isBrandedHouse = window.theme.isBrandedHouse;

            if (!(!isBrandedHouse || attrs.brandedHouse === 'true')) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt('return', false);

          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return shopifyCart.updateAttributes({ brandedHouse: true });

          case 6:
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](3);

            console.warn(_context3.t0);

          case 11:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[3, 8]]);
  }));

  return function addBhAttribute(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var updateLineItem = exports.updateLineItem = function updateLineItem(_ref6) {
  var lineItem = _ref6.lineItem,
      quantity = _ref6.quantity,
      properties = _ref6.properties;

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch) {
      var data, wantedQuantity, actualQuantity, wantedQuantityAndActualQuantityAreTheSame;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return shopifyCart.updateItem(lineItem.key, {
                quantity: quantity,
                properties: (0, _assign2.default)({}, lineItem.properties, properties)
              });

            case 2:
              data = _context4.sent;
              wantedQuantity = quantity;
              actualQuantity = data.items.find(function (item) {
                return item.title === lineItem.title && item.variant_title === lineItem.variant_title && (0, _stringify2.default)(item.properties) === (0, _stringify2.default)(lineItem.properties);
              }).quantity;
              wantedQuantityAndActualQuantityAreTheSame = wantedQuantity === actualQuantity;

              dispatch(updateLineItems(data));

              if (!wantedQuantityAndActualQuantityAreTheSame) {
                dispatch(addError((0, _errors.ADD_TOO_MANY_ERROR)(wantedQuantity, actualQuantity, lineItem.title)));
              }

            case 8:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var removeLineItem = exports.removeLineItem = function removeLineItem(_ref8) {
  var lineItem = _ref8.lineItem;

  return function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch(setLoading(true));

              _context5.next = 3;
              return shopifyCart.removeItem(lineItem.key);

            case 3:
              data = _context5.sent;

              dispatch(updateLineItems(data));
              dispatch(setLoading(false));

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, undefined);
    }));

    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }();
};

var removeLineItemMixMatchSet = exports.removeLineItemMixMatchSet = function removeLineItemMixMatchSet(lineItemKey) {
  return function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return shopifyCart.removeItem(lineItemKey);

            case 3:
              _context6.next = 5;
              return shopifyCart.getState();

            case 5:
              data = _context6.sent;

              dispatch(updateLineItems(data));

            case 7:
              _context6.prev = 7;
              return _context6.finish(7);

            case 9:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, undefined, [[0,, 7, 9]]);
    }));

    return function (_x6) {
      return _ref10.apply(this, arguments);
    };
  }();
};

var removeAllLineItems = exports.removeAllLineItems = function removeAllLineItems() {
  return function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch(setLoading(true));

              _context7.next = 3;
              return shopifyCart.clearItems();

            case 3:
              data = _context7.sent;

              dispatch(updateLineItems(data));

              dispatch(setLoading(false));

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, undefined);
    }));

    return function (_x7) {
      return _ref11.apply(this, arguments);
    };
  }();
};

function setDeliveryConfig(deliveryConfig) {
  return {
    type: pushCartTypes.SET_DELIVERY_CONFIG,
    payload: { deliveryConfig: deliveryConfig }
  };
}

function setFreeGiftTiersConfig(freeGiftTiersConfig) {
  return {
    type: pushCartTypes.SET_FREE_GIFT_TIERS_CONFIG,
    payload: { freeGiftTiersConfig: freeGiftTiersConfig }
  };
}

function setItemBeingAddedId(id) {
  return {
    type: pushCartTypes.SET_ITEM_BEING_ADDED_ID,
    payload: { id: id }
  };
}

function setLoading(isLoading) {
  return {
    type: pushCartTypes.SET_LOADING,
    payload: isLoading
  };
}

function addError(message) {
  return {
    type: pushCartTypes.ADD_ERROR,
    payload: {
      error: (0, _assign2.default)({}, {
        key: new Date(),
        show: true,
        message: message
      })
    }
  };
}

function toggleError(key) {
  return {
    type: pushCartTypes.TOGGLE_ERROR,
    payload: { key: key }
  };
}

function removeError(key) {
  return {
    type: pushCartTypes.REMOVE_ERROR,
    payload: { key: key }
  };
}

function removeAllErrors() {
  return {
    type: pushCartTypes.REMOVE_ALL_ERRORS
  };
}

function updateLineItems(data) {
  return {
    type: pushCartTypes.UPDATE_LINE_ITEMS,
    payload: { data: data }
  };
}